/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{margin-right:-12px}hr[_ngcontent-%COMP%]{margin:auto -24px}.mat-dialog-content[_ngcontent-%COMP%]{padding-top:24px}.mat-form-field[_ngcontent-%COMP%]{display:inherit;margin-top:8px}.mat-flat-button[_ngcontent-%COMP%]{color:#fff}.mat-flat-button.confirm-button.confirm-button-red[_ngcontent-%COMP%]{background-color:#f44336}.mat-flat-button.confirm-button[_ngcontent-%COMP%]:not(.confirm-button-red){background-color:#50af64}"];
export { styles as styles };
